import PropTypes from "prop-types";

const annotationProperties = {
  id: PropTypes.number,
  date_created: PropTypes.string,
  date_modified: PropTypes.string,
  date_shared: PropTypes.string,
  date_archived: PropTypes.string,
  end: PropTypes.string.isRequired,
  endoffset: PropTypes.number.isRequired,
  pen_name: PropTypes.string,
  start: PropTypes.string.isRequired,
  startoffset: PropTypes.number.isRequired,
  text: PropTypes.string,
  user: PropTypes.shape({
    unique_id: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
  }),
  dismissed: PropTypes.bool,
  href: PropTypes.string,
};

export const annotationPropType = PropTypes.shape({
  ...annotationProperties,
  in_response_to: PropTypes.shape({
    ...annotationProperties,
    article: PropTypes.object,
    category: PropTypes.string,
  }),
});

export const matchedLegacyArticleLevelPropType = PropTypes.shape({
  content_id: PropTypes.string,
  header_id: PropTypes.number,
  slug: PropTypes.string,
});

export const proseMirrorNodePropType = PropTypes.shape({
  type: PropTypes.string.isRequired,
  // Array of child nodes
  content: PropTypes.array,
  marks: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      attrs: PropTypes.object,
    }),
  ),
  text: PropTypes.string,
});

export const userPropType = PropTypes.shape({
  id: PropTypes.number,
  username: PropTypes.string,
  email: PropTypes.string,
  first_name: PropTypes.string,
  last_name: PropTypes.string,
  name: PropTypes.string,
  is_staff: PropTypes.bool,
  is_school_educator: PropTypes.bool,
});
